
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmGoogle as ObiAlarmGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-google.js';
 
 
 

 
 export const ObiAlarmGoogle = createComponent({
   react: React,
   tagName: 'obi-alarm-google',
   elementClass: ObiAlarmGoogleElement,
   events: {
     
   }
  });
 
 